export default __webpack_public_path__ + "static/media/1.76c8ecb8.jpeg";